import React from "react";
import { Box } from "@material-ui/core";
import { FastField } from "formik";
import { TextField } from "formik-material-ui";
import useStyles from "./style";

export default function FormTextArea({
  name,
  label,
  placeholder,
  py,
  ...restProps
}) {
  const classes = useStyles();
  return (
    <Box py={py} className={classes.root}>
      <FastField
        name={name}
        label={label}
        component={TextField}
        variant="outlined"
        fullWidth={true}
        placeholder={placeholder}
        multiline
        InputLabelProps={{
          shrink: true,
        }}
        rows={3}
        {...restProps}
      />
    </Box>
  );
}

FormTextArea.defaultProps = {
  name: "",
  label: "",
  placeholder: "",
  py: 1,
};
